import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';

@Component({
    selector: 'app-chart-kpi-gauge',
    templateUrl: './chart-kpi-gauge.component.html',
    styleUrls: ['./chart-kpi-gauge.component.scss'],
    standalone: false
})
export class ChartKpiGaugeComponent implements OnInit, OnChanges {
  @Input() hc: any = {};
  @Input() chartData: any;
  @Input() metrics: any = {};

  gaugeChart: any;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    this.gaugeChart = this.buildChart();
  }

  ngOnInit(): void {}

  buildChart() {
    const chartData = this.chartData;
    const that = this;

    const min = chartData?.bands
      .map((data: any) => data.from)
      .reduce((prev: any, cur: any) => {
        return cur < (prev ?? 99999) ? cur : prev ?? 99999;
      });

    const max = chartData?.bands
      .map((data: any) => data.to)
      .reduce((prev: any, cur: any) => {
        return cur > (prev ?? -99999) ? cur : prev ?? -99999;
      });

    return {
      chart: {
        type: 'gauge',
        plotBackgroundColor: null,
        plotBackgroundImage: null,
        plotBorderWidth: 0,
        plotShadow: false,
        height: '70%',
        backgroundColor: '#FFFFFF00',
      },
      title: {
        text: '',
      },
      pane: {
        startAngle: -86,
        endAngle: 86,
        background: {
          borderWidth: 0,
          borderColor: 'transparent',
          backgroundColor: 'transparent',
          innerRadius: 0,
        },
        center: ['50%', '45%'],
        size: '85%',
      },
      tooltip: {
        formatter: function () {
          return false;
        },
      },

      // the value axis
      yAxis: {
        min: min,
        max: max,
        tickPositions: chartData?.labels.map((data: any) => data.data) ?? [],
        tickColor: '#FFFFFF',
        tickLength: 0,
        tickWidth: 0,
        minorTickInterval: null,
        lineWidth: 0,
        labels: {
          distance: 27,
          style: {
            fontSize: '12px',
            fontFamily: '"Nunito"',
            fontWeight: 'bolder',
            color: '#334AA5',
          },
          formatter: function () {
            try {
              const target = (this as any).pos;

              if (chartData != null) {
                return (
                  chartData?.labels.find((item: any) => item.data === target)
                    ?.label ?? ' - '
                );
              }

              return '';
            } catch (e) {}
            return '';
          },
        },
        plotBands:
          chartData?.bands.map((data: any) => {
            return {
              thickness: 30,
              from: data.from,
              to: data.to,
              color: data.color, // green
              innerRadius: '78%',
              borderWidth: 0,
              bordorColor: data.color,
            };
          }) ?? [],
      },
      series: [
        {
          name: 'data',
          data: [chartData?.data],
          dataLabels: {
            enabled: false,
          },
          dial: {
            radius: '75%', //length of pointer stick
            backgroundColor: '#5D64A4',
            baseWidth: 1.5, //pointer stick width
            baseLength: '75%',
            rearLength: '0%',
          },
          pivot: {
            backgroundColor: '#5D64A4',
            radius: 15,
          },
        },
      ],
      credits: {
        enabled: false,
      },
    };
  }
}
